<template>
  <footer class="bc-page-content">
    <div class="flex">
      <img class="logo" :src="require('assets/footer_logo.png')" alt="Biconomy" />
    </div>

    <div class="footer-link-wrapper">
      <template v-for="(item, i) in links">
        <div 
          class="footer-link-list"
          :class="{ 'active': activeLink === i }"
          :key="item.title"
        >
          <div class="title-wrap" @click="activeLink = activeLink === i ? -1 : i">
            <p class="title">{{ item.title }}</p>
            <SvgIcon name="arrow-down" :class="{ reverse: activeLink === i }" />
          </div>

          <div class="footer-link-wrap">
            <template v-for="h in item.children">
              <template v-if="h">
                <a 
                  :key="h.name" 
                  class="footer-link-item"
                  :href="h.href"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ h.name }}
                </a>
              </template>
            </template>
          </div>
        </div>
      </template>
    </div>

    <!-- <div class="partners-wrapper">
      <p class="partners-title">{{ $t('defi_projects') }}</p>
      <div class="partners-item">
      <Space :size="[36, 12]" :wrapItem="false">
        <a href="https://app.crowdswap.org/?utm_source=biconomy&utm_medium=website&utm_campaign=listing&utm_content=homepage" class="partner-text" target="_blank" rel="noopener noreferrer">
          <svg width="133" height="32" viewBox="0 0 133 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.7418 8.9379C28.1801 8.73462 28.6164 8.56414 29.0473 8.42774C29.9468 8.14158 30.8273 7.99887 31.6826 7.99902C33.5563 7.99902 35.3073 8.68406 36.8628 10.0456C39.224 12.1111 40.0976 14.9172 39.3232 17.9451C38.5271 21.057 36.4177 23.0844 33.2243 23.8065C31.6758 24.1559 30.2752 23.9932 29.0625 23.611C27.89 23.2429 26.8942 22.6705 26.1112 22.1614C25.3985 21.6982 24.728 21.1899 24.0881 20.6564C25.0909 20.5012 25.8737 19.6791 25.9709 18.6568C26.7292 19.2821 27.5269 19.8558 28.3874 20.3295C30.1456 21.2975 31.6616 21.5039 33.1579 20.9839C35.3795 20.2105 36.5651 18.7315 36.782 16.4638C36.9806 14.3841 36.1648 12.7457 34.3608 11.5933C32.667 10.512 30.8599 10.4672 28.8367 11.4589C27.4386 12.1437 26.2204 13.0875 25.0446 14.1547C24.7085 14.4582 24.376 14.772 24.0438 15.0931C23.9967 15.1389 23.9202 15.1333 23.8798 15.0817C23.2 14.2119 23.0061 13.0847 23.3024 12.0685C23.3083 12.0484 23.3196 12.0305 23.3351 12.0165C24.6215 10.8562 26.0485 9.72174 27.7418 8.9379Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.27504 17.9456C1.50058 14.9177 2.37439 12.1116 4.73566 10.0461C6.2911 8.68447 8.04183 7.99936 9.91588 7.99951C10.7708 7.99951 11.6517 8.14207 12.5511 8.42823C12.9818 8.56463 13.4181 8.73511 13.8565 8.93839C15.1297 9.52775 16.2524 10.3154 17.2779 11.1631C16.241 11.2421 15.4052 12.0416 15.2685 13.0629C14.4827 12.4455 13.6593 11.8991 12.7615 11.4594C10.7384 10.4677 8.93123 10.5125 7.23749 11.5938C5.43352 12.7462 4.61771 14.3846 4.81612 16.4643C5.03327 18.732 6.21882 20.211 8.44042 20.9844C9.93684 21.5044 11.4527 21.298 13.2109 20.33C14.1193 19.8298 14.9582 19.2182 15.7542 18.5519C15.8949 18.435 16.0433 18.3313 16.1969 18.2438C17.283 17.6226 18.8275 17.7539 19.8284 18.5649C19.88 18.6067 19.8833 18.685 19.8351 18.7308C19.4447 19.0994 18.9927 19.4572 18.5467 19.8104C18.2636 20.0345 17.983 20.2567 17.7218 20.4787C17.0184 21.0772 16.2788 21.6474 15.4871 22.1619C14.704 22.671 13.7084 23.2434 12.5358 23.6115C11.3229 23.9937 9.92268 24.1564 8.37395 23.807C5.18052 23.0849 3.0712 21.0575 2.27504 17.9456Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M23.7425 16.6475C24.7319 16.6475 25.5339 17.4507 25.5339 18.4415C25.5339 19.4323 24.7319 20.2356 23.7425 20.2356C22.7531 20.2356 21.9512 19.4324 21.9512 18.4415C21.9512 17.4507 22.7531 16.6475 23.7425 16.6475Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.451 11.6016C18.4185 11.6016 19.2029 12.3871 19.2029 13.3562C19.2029 14.3252 18.4185 15.1108 17.451 15.1108C16.4836 15.1108 15.6992 14.3252 15.6992 13.3562C15.6992 12.3871 16.4836 11.6016 17.451 11.6016Z" fill="currentColor"/>
            <path d="M50.1252 22.5579C48.5892 22.5579 47.3571 22.0353 46.4291 20.9899C45.5011 19.9339 45.0371 18.4566 45.0371 16.5579C45.0371 14.6699 45.4798 13.1979 46.3651 12.1419C47.2611 11.0859 48.4985 10.5579 50.0772 10.5579C50.9092 10.5579 51.6506 10.6379 52.3012 10.7979C52.4612 10.8406 52.5892 10.9313 52.6852 11.0699C52.7919 11.2086 52.8452 11.3633 52.8452 11.5339C52.8452 11.6726 52.7866 11.7846 52.6692 11.8699C52.5626 11.9446 52.4399 11.9606 52.3012 11.9179C51.6719 11.7259 50.9678 11.6299 50.1892 11.6299C48.9838 11.6299 48.0398 12.0619 47.3571 12.9259C46.6745 13.7899 46.3331 15.0006 46.3331 16.5579C46.3331 18.1046 46.6851 19.3153 47.3891 20.1899C48.1038 21.0539 49.0532 21.4859 50.2372 21.4859C51.0266 21.4859 51.7412 21.3899 52.3812 21.1979C52.5199 21.1553 52.6426 21.1766 52.7492 21.2619C52.8666 21.3366 52.9252 21.4433 52.9252 21.5819C52.9252 21.7526 52.8719 21.9073 52.7652 22.0459C52.6692 22.1739 52.5412 22.2593 52.3812 22.3019C51.6666 22.4726 50.9146 22.5579 50.1252 22.5579ZM56.6615 22.2059C56.5442 22.3339 56.3949 22.3979 56.2135 22.3979C56.0322 22.3979 55.8775 22.3339 55.7495 22.2059C55.6322 22.0779 55.5735 21.9286 55.5735 21.7579V14.6859C55.5735 14.5153 55.6322 14.3713 55.7495 14.2539C55.8669 14.1366 56.0109 14.0779 56.1815 14.0779C56.3522 14.0779 56.4962 14.1366 56.6135 14.2539C56.7309 14.3713 56.7895 14.5153 56.7895 14.6859V15.9179C56.7895 15.9286 56.7949 15.9339 56.8055 15.9339C56.8269 15.9339 56.8375 15.9233 56.8375 15.9019C57.1575 15.3686 57.6055 14.9419 58.1816 14.6219C58.7682 14.2913 59.4242 14.1099 60.1496 14.0779C60.2989 14.0673 60.427 14.1153 60.5336 14.2219C60.6402 14.3286 60.6936 14.4566 60.6936 14.6059C60.6936 14.7446 60.6402 14.8673 60.5336 14.9739C60.4376 15.0806 60.3149 15.1393 60.1656 15.1499C59.1096 15.1926 58.2936 15.5019 57.7175 16.0779C57.1415 16.6433 56.8535 17.4379 56.8535 18.4619V21.7579C56.8535 21.9286 56.7895 22.0779 56.6615 22.2059ZM68.5924 18.2379C68.5924 15.9979 67.739 14.8779 66.0323 14.8779C64.3256 14.8779 63.4723 15.9979 63.4723 18.2379C63.4723 20.4779 64.3256 21.5979 66.0323 21.5979C67.739 21.5979 68.5924 20.4779 68.5924 18.2379ZM68.8324 21.4219C68.1603 22.1793 67.227 22.5579 66.0323 22.5579C64.8377 22.5579 63.9043 22.1793 63.2323 21.4219C62.5603 20.6646 62.2243 19.6033 62.2243 18.2379C62.2243 16.8726 62.5603 15.8113 63.2323 15.0539C63.9043 14.2966 64.8377 13.9179 66.0323 13.9179C67.227 13.9179 68.1603 14.2966 68.8324 15.0539C69.5044 15.8113 69.8404 16.8726 69.8404 18.2379C69.8404 19.6033 69.5044 20.6646 68.8324 21.4219ZM73.3428 21.6299L71.4388 14.7179C71.3961 14.5579 71.4228 14.4139 71.5188 14.2859C71.6254 14.1473 71.7641 14.0779 71.9348 14.0779C72.1268 14.0779 72.2975 14.1366 72.4468 14.2539C72.6068 14.3713 72.7081 14.5259 72.7508 14.7179L74.3348 21.3259C74.3348 21.3366 74.3401 21.3419 74.3508 21.3419C74.3615 21.3419 74.3668 21.3366 74.3668 21.3259L75.8709 14.8779C75.9349 14.6433 76.0575 14.4513 76.2389 14.3019C76.4309 14.1526 76.6442 14.0779 76.8789 14.0779C77.1242 14.0779 77.3429 14.1526 77.5349 14.3019C77.7269 14.4513 77.8495 14.6433 77.9029 14.8779L79.3909 21.3259C79.3909 21.3366 79.4016 21.3419 79.4229 21.3419C79.4336 21.3419 79.4389 21.3366 79.4389 21.3259L81.0233 14.7019C81.0761 14.5206 81.1721 14.3713 81.3113 14.2539C81.4601 14.1366 81.6313 14.0779 81.8233 14.0779C81.9833 14.0779 82.1113 14.1473 82.2073 14.2859C82.3033 14.4139 82.3297 14.5526 82.2873 14.7019L80.3829 21.6299C80.3189 21.8539 80.1909 22.0406 79.9989 22.1899C79.8176 22.3286 79.6096 22.3979 79.3749 22.3979C79.1509 22.3979 78.9429 22.3233 78.7509 22.1739C78.5695 22.0246 78.4469 21.8379 78.3829 21.6139L76.8789 15.2619C76.8789 15.2513 76.8735 15.2459 76.8629 15.2459C76.8522 15.2459 76.8469 15.2513 76.8469 15.2619L75.3429 21.6139C75.2895 21.8379 75.1669 22.0246 74.9749 22.1739C74.7935 22.3233 74.5855 22.3979 74.3508 22.3979C74.1268 22.3979 73.9188 22.3286 73.7268 22.1899C73.5348 22.0406 73.4068 21.8539 73.3428 21.6299ZM87.4514 14.8779C85.8513 14.8779 85.0513 15.9979 85.0513 18.2379C85.0513 19.3473 85.2593 20.1846 85.6753 20.7499C86.1017 21.3153 86.6938 21.5979 87.4514 21.5979C88.0698 21.5979 88.625 21.3846 89.1154 20.9579C89.6058 20.5206 89.8514 20.0246 89.8514 19.4699V17.0059C89.8514 16.4619 89.6058 15.9713 89.1154 15.5339C88.6354 15.0966 88.081 14.8779 87.4514 14.8779ZM87.1954 22.5579C86.2033 22.5579 85.3929 22.1739 84.7633 21.4059C84.1449 20.6273 83.8353 19.5713 83.8353 18.2379C83.8353 16.8619 84.1337 15.8006 84.7313 15.0539C85.3393 14.2966 86.1609 13.9179 87.1954 13.9179C88.241 13.9179 89.1098 14.3286 89.8034 15.1499C89.8138 15.1606 89.825 15.1659 89.8354 15.1659C89.8458 15.1659 89.8514 15.1606 89.8514 15.1499V11.0059C89.8514 10.8353 89.9098 10.6913 90.0274 10.5739C90.1554 10.4566 90.305 10.3979 90.4754 10.3979C90.6458 10.3979 90.7898 10.4566 90.9074 10.5739C91.025 10.6913 91.0834 10.8353 91.0834 11.0059V21.8219C91.0834 21.9819 91.025 22.1206 90.9074 22.2379C90.801 22.3446 90.6674 22.3979 90.5074 22.3979C90.3474 22.3979 90.209 22.3446 90.0914 22.2379C89.9738 22.1206 89.9154 21.9819 89.9154 21.8219V21.2299C89.9154 21.2193 89.9098 21.2139 89.8994 21.2139C89.889 21.2139 89.8778 21.2193 89.8674 21.2299C89.153 22.1153 88.2618 22.5579 87.1954 22.5579ZM96.9571 16.9099C94.7491 16.1633 93.6451 14.9953 93.6451 13.4059C93.6451 12.5099 93.9331 11.8113 94.5091 11.3099C95.0851 10.8086 95.8907 10.5579 96.9251 10.5579C97.8851 10.5579 98.7763 10.7019 99.5972 10.9899C99.7684 11.0539 99.9068 11.1659 100.013 11.3259C100.12 11.4753 100.173 11.6459 100.173 11.8379C100.173 11.9766 100.115 12.0833 99.9972 12.1579C99.8804 12.2219 99.7572 12.2273 99.6292 12.1739C98.7651 11.7899 97.8963 11.5979 97.0211 11.5979C96.3811 11.5979 95.8643 11.7473 95.4691 12.0459C95.0851 12.3446 94.8931 12.7979 94.8931 13.4059C94.8931 14.4513 95.5923 15.2086 96.9891 15.6779C98.3123 16.1153 99.2404 16.6166 99.7732 17.1819C100.307 17.7473 100.573 18.4726 100.573 19.3579C100.573 20.4033 100.259 21.1979 99.6292 21.7419C99.0003 22.2859 98.0771 22.5579 96.8611 22.5579C95.9443 22.5579 95.1171 22.3926 94.3811 22.0619C94.0083 21.8913 93.8211 21.5926 93.8211 21.1659C93.8211 21.0273 93.8803 20.9259 93.9971 20.8619C94.1147 20.7979 94.2323 20.7979 94.3491 20.8619C95.0747 21.2779 95.8803 21.4859 96.7651 21.4859C98.4507 21.4859 99.2931 20.7766 99.2931 19.3579C99.2931 18.7819 99.1124 18.3019 98.7491 17.9179C98.3867 17.5339 97.7891 17.1979 96.9571 16.9099ZM104.24 21.6299L102.336 14.7179C102.294 14.5579 102.32 14.4139 102.416 14.2859C102.524 14.1473 102.662 14.0779 102.832 14.0779C103.024 14.0779 103.196 14.1366 103.344 14.2539C103.504 14.3713 103.606 14.5259 103.648 14.7179L105.232 21.3259C105.232 21.3366 105.238 21.3419 105.248 21.3419C105.26 21.3419 105.264 21.3366 105.264 21.3259L106.768 14.8779C106.832 14.6433 106.956 14.4513 107.136 14.3019C107.328 14.1526 107.542 14.0779 107.776 14.0779C108.022 14.0779 108.24 14.1526 108.432 14.3019C108.624 14.4513 108.748 14.6433 108.8 14.8779L110.289 21.3259C110.289 21.3366 110.3 21.3419 110.321 21.3419C110.332 21.3419 110.337 21.3366 110.337 21.3259L111.921 14.7019C111.974 14.5206 112.07 14.3713 112.209 14.2539C112.358 14.1366 112.529 14.0779 112.721 14.0779C112.881 14.0779 113.009 14.1473 113.105 14.2859C113.201 14.4139 113.228 14.5526 113.185 14.7019L111.281 21.6299C111.217 21.8539 111.089 22.0406 110.897 22.1899C110.716 22.3286 110.508 22.3979 110.273 22.3979C110.049 22.3979 109.841 22.3233 109.649 22.1739C109.468 22.0246 109.344 21.8379 109.28 21.6139L107.776 15.2619C107.776 15.2513 107.772 15.2459 107.76 15.2459C107.75 15.2459 107.744 15.2513 107.744 15.2619L106.24 21.6139C106.188 21.8379 106.064 22.0246 105.872 22.1739C105.692 22.3233 105.484 22.3979 105.248 22.3979C105.024 22.3979 104.816 22.3286 104.624 22.1899C104.432 22.0406 104.304 21.8539 104.24 21.6299ZM119.245 17.9979C118.189 17.9979 117.389 18.1686 116.845 18.5099C116.312 18.8513 116.045 19.3313 116.045 19.9499C116.045 20.4299 116.178 20.8193 116.445 21.1179C116.722 21.4059 117.085 21.5499 117.533 21.5499C118.301 21.5499 118.936 21.2939 119.437 20.7819C119.949 20.2699 120.205 19.5926 120.205 18.7499V18.1419C120.205 18.0459 120.157 17.9979 120.061 17.9979H119.245ZM117.277 22.5579C116.552 22.5579 115.96 22.3286 115.501 21.8699C115.042 21.4113 114.813 20.8033 114.813 20.0459C114.813 19.1606 115.165 18.4513 115.869 17.9179C116.573 17.3846 117.698 17.1179 119.245 17.1179H120.061C120.157 17.1179 120.205 17.0753 120.205 16.9899V16.6859C120.205 16.0353 120.056 15.5819 119.757 15.3259C119.458 15.0593 118.93 14.9259 118.173 14.9259C117.437 14.9259 116.642 15.0646 115.789 15.3419C115.661 15.3846 115.544 15.3686 115.437 15.2939C115.33 15.2193 115.277 15.1126 115.277 14.9739C115.277 14.6006 115.453 14.3606 115.805 14.2539C116.594 14.0299 117.384 13.9179 118.173 13.9179C119.4 13.9179 120.248 14.1419 120.717 14.5899C121.197 15.0379 121.437 15.8433 121.437 17.0059V21.8219C121.437 21.9819 121.378 22.1206 121.261 22.2379C121.154 22.3446 121.021 22.3979 120.861 22.3979C120.701 22.3979 120.562 22.3446 120.445 22.2379C120.328 22.1206 120.269 21.9819 120.269 21.8219L120.253 20.9899C120.253 20.9793 120.248 20.9739 120.237 20.9739C120.216 20.9739 120.205 20.9846 120.205 21.0059C119.576 22.0406 118.6 22.5579 117.277 22.5579ZM125.312 17.1019V19.3739C125.312 19.9819 125.552 20.5046 126.032 20.9419C126.512 21.3793 127.072 21.5979 127.712 21.5979C128.47 21.5979 129.056 21.3153 129.472 20.7499C129.899 20.1739 130.112 19.3366 130.112 18.2379C130.112 15.9979 129.312 14.8779 127.712 14.8779C127.062 14.8779 126.496 15.1019 126.016 15.5499C125.547 15.9873 125.312 16.5046 125.312 17.1019ZM125.136 25.7419C125.019 25.8593 124.875 25.9179 124.704 25.9179C124.534 25.9179 124.384 25.8593 124.256 25.7419C124.139 25.6246 124.08 25.4806 124.08 25.3099V14.6539C124.08 14.4939 124.134 14.3606 124.24 14.2539C124.358 14.1366 124.496 14.0779 124.656 14.0779C124.816 14.0779 124.955 14.1366 125.072 14.2539C125.19 14.3606 125.248 14.4939 125.248 14.6539L125.264 15.2619C125.264 15.2726 125.27 15.2779 125.28 15.2779L125.312 15.2459C126.016 14.3606 126.907 13.9179 127.984 13.9179C129.019 13.9179 129.835 14.2966 130.432 15.0539C131.04 15.8006 131.344 16.8619 131.344 18.2379C131.344 19.5713 131.03 20.6273 130.4 21.4059C129.782 22.1739 128.976 22.5579 127.984 22.5579C126.896 22.5579 126.022 22.1473 125.36 21.3259C125.35 21.3153 125.339 21.3099 125.328 21.3099C125.318 21.3099 125.312 21.3153 125.312 21.3259V25.3099C125.312 25.4806 125.254 25.6246 125.136 25.7419Z" fill="currentColor"/>
          </svg>
        </a>
      </Space>
      </div>
    </div> -->

    <div class="community-wrapper">
      <p>{{ $t('footer_community') }}</p>

      <Space :size="[24, 12]" :wrapItem="false">
        <template v-for="(item, i) in communityList">
          <Popover
            v-if="item.type === 'telegram'" 
            :key="i" 
            :referenceArrow="false"
            placement="top"
            trigger="hover"
          >
            <div class="community-item">
              <img :src="item.icon">
            </div>

            <template slot="popper">
              <Scrollbar height="2rem" class="telegram-list" always>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  v-for="item in telegramList"
                  :key="item.name"
                  :href="item.link"
                >
                  <img class="flag-icon" :src="getOssUrl(item.code)" />
                  {{ item.name }}</a
                >
              </Scrollbar>
            </template>
          </Popover>

          <a 
            v-else
            class="community-item"
            :key="i" 
            :href="item.link" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <img :src="item.icon">
          </a>
        </template>
      </Space>
    </div>

    <p class="copyright" v-html="copyright"></p>
  </footer>
</template>

<script>
import Popover from 'components/common/popover'
import { telegramList } from 'utils/telegram-list';
import { getOssDoc } from 'utils/oss';
import { mapState } from 'vuex';

export default {
  name: 'Footer',
  components: {
    Popover
  },
  data() {
    return {
      telegramList,
      lang: this.$lang.getLang(),
      communityList: [
        { link: 'https://twitter.com/BiconomyCom', icon: require('assets/client/home/community/twitter.png') },
        { type: 'telegram', icon: require('assets/client/home/community/telegram.png') },
        { link: 'https://www.facebook.com/BiconomyCom', icon: require('assets/client/home/community/facebook.png') },
        { link: 'https://www.linkedin.com/company/biconomycom', icon: require('assets/client/home/community/linkedin.png') },
        { link: 'https://www.youtube.com/c/BiconomyGlobal', icon: require('assets/client/home/community/youtube.png') },
        { link: 'https://www.tiktok.com/@biconomycom?_t=8hxL7yv2ojN&_r=1', icon: require('assets/client/home/community/tiktok.png') },
        { link: 'https://www.instagram.com/biconomy/', icon: require('assets/client/home/community/ins.png') },
        { link: 'https://discord.gg/QQBZKfQnaY', icon: require('assets/client/home/community/discord.png') },
        { link: 'https://biconomycom.medium.com', icon: require('assets/client/home/community/medium.png') },
        { link: 'https://www.reddit.com/r/biconomyExchange/', icon: require('assets/client/home/community/reddit.png') },
        { link: 'https://coinmarketcap.com/exchanges/biconomy/', icon: require('assets/client/home/community/cmc.png') },
        { link: 'https://www.coingecko.com/en/exchanges/biconomy', icon: require('assets/client/home/community/coingecko.png') }
      ],
      zendeskLang: {
        'zh-hant': 'zh-hk',
        ko: 'ko',
        ru: 'ru',
        'pt-PT': 'pt-pt',
        tr: 'tr-tr',
        'es-es': 'es-es'
      },
      activeLink: -1,
      copyright: this.$t('footer_copyright', { link: '<a class="text-primary" href="https://www.biconomy.com">Biconomy.com</a>' })
    }
  },
  computed: {
    ...mapState(['area']),
    links() {
      const zendesk = this.zendeskLang[this.lang] || 'en-us';

      return [
        {
          title: 'Biconomy',
          children: [
            {
              name: this.$t('footer.AboutUs'),
              href: '/about',
            },
            {
              name: this.$t('Careers'),
              href: '/careers'
            },
            {
              name: this.$t('media_kit'),
              href: '/BrandKit'
            },
            {
              name: this.$t('referral_program'),
              href: '/user-center/invitation'
            },
            {
              name: this.$t('feedback_and_suggestions'),
              href: 'mailto:support@biconomy.com',
              target: '_blank',
              rel: 'noopener noreferrer'
            },
            {
              name: this.$t('footer.bit'),
              href: '/bittoken',
            },
            {
              name: this.$t('ambassador.faqs'),
              href: `https://biconomy.zendesk.com/hc/en-us/categories/360002352932-FAQs`,
              target: '_blank',
              rel: 'noopener noreferrer'
            },
            {
              name: this.$t('footer.Announcements'),
              href: `https://biconomy.zendesk.com/hc/${zendesk}`,
              target: '_blank',
              rel: 'noopener noreferrer'
            },
            {
              name: this.$t('footer.Fees'),
              href: '/fee'
            },
            // 'footer.Termsofservice',
            // 'footer.PrivacyPolicy'
            // 'footer.news'
            {
              name: this.$t('terms_of'),
              href: `https://biconomy.zendesk.com/hc/en-us/articles/360036401031-Terms-of-service`,
              target: '_blank',
              rel: 'noopener noreferrer'
            },
            {
              name: this.$t('privacy_policy'),
              href: `https://biconomy.zendesk.com/hc/en-us/articles/360036040012-Privacy-policy`,
              target: '_blank',
              rel: 'noopener noreferrer'
            },
            {
              name: this.$t('kyc_aml'),
              href: `https://biconomy.zendesk.com/hc/en-us/articles/360036979172-Know-your-customers-and-Anti-Money-Laundering-Policies`,
              target: '_blank',
              rel: 'noopener noreferrer'
            }
          ]
        },
        {
          title: this.$t('footer.Products'),
          children: [
            {
              name: this.$t('spot_trading'),
              href: '/exchange/BTC_USDT'
            },
            {
              name: this.$t('Futures'),
              href: '/futures/BTCUSDT'
            },
            {
              name: this.$t('biconomy_earn'),
              href: '/earn'
              // beta: true
            },
            {
              name: this.$t('crypto.title'),
              href: '/buycrypto'
            },
            {
              name: 'Launchpad',
              href: '/launchpad'
            },
            {
              name: 'DAO',
              href: '/dao'
            },
            {
              name: this.$t('Staking'),
              href: '/farms/',
              target: '_blank',
              rel: 'noopener noreferrer'
            },
            {
              name: 'NFT',
              href: '/nft',
              // coming: true
              beta: true
            },
            {
              name: 'LIVE',
              href: '/live'
              // coming: true
              // beta: true
            }
            // 'footer.markets',
            // 'footer.exchange'
            //  'footer.buycrypto'
          ]
        },
        {
          title: this.$t('support_services'),
          children: [
            {
              name: this.$t('submit_request'),
              href: `https://biconomy.zendesk.com/hc/${zendesk}/requests/new`,
              target: '_blank',
              rel: 'noopener noreferrer'
            },
            {
              name: this.$t('official_verification'),
              href: '/anti-fake',
            },
            {
              name: this.$t('business_contacts'),
              href: 'mailto:business@biconomy.com',
              target: '_blank',
              rel: 'noopener noreferrer'
            },
            // 'footer.Fees',
            {
              name: this.$t('beginner_guide'),
              href: 'https://www.biconomy.com/blog',
              target: '_blank',
              rel: 'noopener noreferrer'
            },
            {
              name: this.$t('Biconomy Blog'),
              href: 'https://www.biconomy.com/blog',
            },
            {
              name: this.$t('footer.API'),
              href: 'https://github.com/BiconomyOfficial/apidocs',
              target: '_blank',
              rel: 'noopener noreferrer'
            },
            {
              name: this.$t('certification.title'),
              href: `https://biconomy.zendesk.com/hc/en-us/articles/4407360156569-How-to-complete-Biconomy-Identity-Verification-`,
              target: '_blank',
              rel: 'noopener noreferrer'
            }
          ]
        },
        {
          title: this.$t('footer.business'),
          children: [
            {
              name: this.$t('token_listing'),
              href: '/business/listings'
            },
            {
              name: this.$t('listing_application'),
              href: 'https://docs.google.com/forms/d/1QVHTXUu-KwO6qBjqmmzVULtMODa5D3RazxKTi64HKyE/viewform?edit_requested=true',
              target: '_blank',
              rel: 'noopener noreferrer'
            },
            {
              name: this.$t('launchpad_application'),
              href: 'https://docs.google.com/forms/d/e/1FAIpQLSeMqa_DW1fvj9lTEfUYTwcrX6SHFMkBN2A8Au62D8SfcKEfsQ/viewform?vc=0&c=0&w=1&flr=0',
              target: '_blank',
              rel: 'noopener noreferrer'
            },
            {
              name: this.$t('ambassador_program'),
              href: '/ambassadorPage'
            },
            {
              name: this.$t('Futures Affiliate'),
              href: 'https://docs.google.com/forms/d/e/1FAIpQLSeqP7KQTEOy8675lav0ML9anxMIVXTExZa0r6_LZ49Tu0mbvQ/viewform?usp=sf_link',
              target: '_blank',
              rel: 'noopener noreferrer'
            },
            {
              name: 'Labs',
              href: '/labs'
            }
          ]
        },
        // {
        //   title: 'Legal',
        //   children: [
        //     {
        //       name: 'terms_of',
        //       href: `https://biconomy.zendesk.com/hc/en-us/articles/360036401031-Terms-of-service`,
        //       target: '_blank',
        //       rel: "noopener noreferrer"
        //     },
        //     {
        //       name: 'privacy_policy',
        //       href: `https://biconomy.zendesk.com/hc/en-us/articles/360036040012-Privacy-policy`,
        //       target: '_blank',
        //       rel: "noopener noreferrer"
        //     },
        //     {
        //       name: 'kyc_aml',
        //       href: `https://biconomy.zendesk.com/hc/en-us/articles/360036979172-Know-your-customers-and-Anti-Money-Laundering-Policies`,
        //       target: '_blank',
        //       rel: "noopener noreferrer"
        //     }
        //   ]
        // },
        {
          title: this.$t('crypto.title'),
          children: [
            {
              name: 'Biconomy Exchange Token(BIT)',
              href: `/exchange/BIT_USDT`,
              target: '_blank'
            },
            {
              name: 'Bitcoin(BTC)',
              href: `/exchange/BTC_USDT`,
              target: '_blank'
            },
            // 'footer.Fees',
            {
              name: 'Ethereum(ETH)',
              href: '/exchange/ETH_USDT',
              target: '_blank'
            },
            {
              name: 'Tron(TRX)',
              href: '/exchange/TRX_USDT',
              target: '_blank'
            },
            {
              name: 'Litecoin(LTC)',
              href: '/exchange/LTC_USDT',
              target: '_blank'
            },
            {
              name: 'ApeCoin(APE)',
              href: '/exchange/APE_USDT',
              target: '_blank'
            },
            {
              name: 'Filecoin(FIL)',
              href: '/exchange/FIL_USDT',
              target: '_blank'
            },
            {
              name: 'ChainLink(LINK)',
              href: '/exchange/LINK_USDT',
              target: '_blank'
            },
            {
              name: 'Uniswap(UNI)',
              href: '/exchange/UNI_USDT',
              target: '_blank'
            },
            {
              name: 'Aptos(APT)',
              href: '/exchange/APT_USDT',
              target: '_blank'
            },
            {
              name: 'Dogecoin(DOGE)',
              href: '/exchange/DOGE_USDT',
              target: '_blank'
            },
            {
              name: 'Shiba Inu(SHIB)',
              href: '/exchange/SHIB_USDT',
              target: '_blank'
            },
            {
              name: 'CROWD(CrowdSwap)',
              href: '/exchange/CROWD_USDT',
              target: '_blank'
            }
          ]
        }
      ];
    },
  },
  methods: {
    getOssUrl(code) {
      return getOssDoc(`/flags_png/${code}.png`);
    }
  }
}
</script>
<style lang="scss" scoped>
.telegram-list {
  padding: 0.1rem 0.04rem;

  a {
    @include flex;
    color: inherit;
    padding: 0.04rem 0.08rem;

    &:hover {
      background-color: $gray-hover;
    }

    img {
      margin-inline-end: 0.15rem;
      width: 0.15rem;
    }
  }
}
</style>

<style lang="scss" scoped>
footer {
  padding-top: 0.8rem;
  padding-bottom: 0.32rem;

  .flex {
    @include flex(space-between, center, wrap);
    @include text-lg;
    margin-bottom: 0.56rem;

    img {
      height: 0.4rem;
      margin-inline-end: 0.12rem;
    }
  }

  .footer-link-wrapper {
    @include flex(space-between, flex-start);

    .footer-link-list {
      flex: 1;
      padding: 0.16rem 0.1rem;
      border-radius: 0.08rem;
      background: linear-gradient(180deg, rgba(217, 217, 217, 0.05) 0%, rgba(217, 217, 217, 0) 100%);

      &:not(:last-of-type) {
        margin-inline-end: 0.15rem;
      }

      .title-wrap {
        height: 0.4rem;
        @include flex(space-between);
      }

      .bc-icon-arrow-down {
        font-size: 0.24rem;
        display: none;
        transition: transform .3s;

        &.reverse {
          transform: rotate(180deg);
        }
      }

      .title {
        font-size: 0.16rem;
        font-weight: 700;
        line-height: 0.24rem;
        flex: 1;
      }

      .footer-link-wrap {
        margin-top: 0.18rem;
      }

      a {
        display: block;
        width: 100%;
        color: inherit;
        margin-bottom: 8px;

        &:hover {
          color: $main-color;
          text-decoration: underline;
        }
      }
    }
  }

  .partners-wrapper {
    margin-top: 0.16rem;
    padding-left: 0.16rem;
    border-radius: 0.08rem;
    background-color: rgb(217, 217, 217, 0.05);
    box-shadow: 0px 0.04rem 0.12rem 0px rgba(0, 0, 0, 0);
    .partners-title{
      @include text-lg(700);
      padding: 0.16rem 0 0.16rem 0;
    }

    .partners-item {
      padding-bottom: 0.36rem;
      .partner-text{
        color : currentColor !important;
      }
    }
  }

  .community-wrapper {
    margin-top: 0.6rem;
    margin-bottom: 0.4rem;
    padding: 0.2rem 0.16rem;
    border-radius: 0.08rem;
    background-color: $main-color;
    @include flex(space-between, center, wrap);
    box-shadow: 0px 0.04rem 0.12rem 0px rgba(0, 0, 0, 0.35);
    @include text-2xl(600);
    color: #fff;

    .community-item {
      display: block;
      width: 0.32rem;
      height: 0.32rem;
      border-radius: 50%;
      box-shadow: 0px 0.04rem 0.12rem 0 rgba(0, 0, 0, 0.35);
      
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .copyright {
    text-align: center;

    ::v-deep a {
      color: $main-color;
    }
  }

  @media screen and (max-width: 992px) {
    .community-wrapper {
      justify-content: center;

      p {
        width: 100%;
        text-align: center;
        margin-bottom: 0.12rem;
      }
    }
  }

  @media screen and (max-width: 768px) {
    padding-bottom: 1rem;

    .flex {
      margin-bottom: 0.32rem;

      p {
        margin-top: 0.12rem;
        width: 100%;
      }
    }

    .footer-link-wrapper {
      flex-wrap: wrap;

      .footer-link-list {
        flex: none;
        width: 100%;
        padding: 0.1rem;

        .title-wrap {
          cursor: pointer;
        }

        .bc-icon-arrow-down {
          display: block;
        }

        &:not(.active) {
          .footer-link-wrap {
            display: none;
          }
        }
      }
    }

    .community-wrapper {
      @include text-lg2;
      margin-top: 0.5rem;

      .bc-space {
        width: 100%;
        justify-content: space-around !important;
        gap: 0.12rem !important;
      }
    }
  }
}
</style>